import { render, staticRenderFns } from "./OptimTitle.vue?vue&type=template&id=3bc803b0&"
import script from "./OptimTitle.vue?vue&type=script&lang=js&"
export * from "./OptimTitle.vue?vue&type=script&lang=js&"
import style0 from "./OptimTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports